import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { RouteComponentProps } from 'react-router';
import { CategoryIndex } from '../../components/CategoryIndex';
import { LoadingSpinner } from '../../components/Common/LoadingSpinner';
import { STORE_ADVERT, STORE_CATEGORY, AdvertSlot } from '../../constants';
import { AdvertStore, CategoryStore } from '../../stores';
import './style.css';

// tslint:disable-next-line no-any
export interface CategoryPageProps extends RouteComponentProps<any> {
  /* [STORE_CATEGORY]: CategoryStore; */
}

export interface CategoryPageState {
  /* empty*/
}

@inject(STORE_ADVERT)
@inject(STORE_CATEGORY)
@observer
export class CategoryPage extends React.Component<
  CategoryPageProps,
  CategoryPageState
> {
  async componentDidMount() {
    const categoryStore = this.props[STORE_CATEGORY] as CategoryStore;
    const advertStore = this.props[STORE_ADVERT] as AdvertStore;

    await advertStore.fetchAdvertsForSlot(AdvertSlot.CategoryIndexOne);
    await advertStore.fetchAdvertsForSlot(AdvertSlot.CategoryIndexTwo);
    await categoryStore.fetchCategories();
  }

  render() {
    const { location, match } = this.props;
    const categoryStore = this.props[STORE_CATEGORY] as CategoryStore;
    const advertStore = this.props[STORE_ADVERT] as AdvertStore;

    if (!categoryStore.categories) {
      return <LoadingSpinner className="category-page-loader" />;
    }

    const category = categoryStore.categories.find(
      _category => _category.relativeRoute === match.params.category
    );

    if (!category) {
      return <LoadingSpinner className="category-page-loader" />;
    }

    return (
      <CategoryIndex
        advertSlotOne={advertStore.adverts[AdvertSlot.CategoryIndexOne]}
        advertSlotTwo={advertStore.adverts[AdvertSlot.CategoryIndexTwo]}
        location={location}
        category={category}
      />
    );
  }
}

export default CategoryPage;



// WEBPACK FOOTER //
// ./src/app/containers/CategoryPage/index.tsx